import { getRequiredModuleForPath } from '../utils/authSession.js'
import { checkModuleEntitlement, normalizeModuleCode } from '../utils/moduleAccess.js'


export const EMPLOYEE_MENU_STRUCTURE = [
  {
    id: 'ess-account',
    label: 'My Account',
    icon: 'account_circle',
    basePath: '/self-service/account',
    defaultPath: '/self-service/dashboard',
    submenus: [
      { id: 'dashboard', label: 'Dashboard', icon: 'space_dashboard', path: '/self-service/dashboard', type: 'screen', section: 'self-service', module: 'dashboard' },
      { id: 'my-profile', label: 'My Profile', icon: 'person', path: '/self-service/my-profile', type: 'screen', section: 'self-service', module: 'my-profile' },
      { id: 'company-policy', label: 'Company Policy', icon: 'policy', path: '/self-service/company-policy', type: 'screen', section: 'self-service', module: 'company-policy' },
    ],
  },
  {
    id: 'ess-attendance',
    label: 'Attendance & Time',
    icon: 'schedule',
    basePath: '/self-service/attendance',
    defaultPath: '/self-service/attendance-history',
    submenus: [
      { id: 'attendance-history', label: 'Attendance History', icon: 'history', path: '/self-service/attendance-history', type: 'screen', section: 'self-service', module: 'attendance-history' },
      { id: 'attendance-regularization', label: 'Regularization', icon: 'pending_actions', path: '/self-service/attendance-regularization', entryPath: '/self-service/attendance-regularization/entry', type: 'list-entry', section: 'self-service', module: 'attendance-regularization' },
      { id: 'holiday', label: 'Holidays', icon: 'event', path: '/self-service/holiday', entryPath: '/self-service/holiday/entry', type: 'list-entry', section: 'self-service', module: 'holiday' },
    ],
  },
  {
    id: 'ess-leaves',
    label: 'Leaves & Finance',
    icon: 'payments',
    basePath: '/self-service/leaves',
    defaultPath: '/self-service/leave-balance',
    submenus: [
      { id: 'leave-balance', label: 'Leave Balance', icon: 'pie_chart', path: '/self-service/leave-balance', type: 'screen', section: 'self-service', module: 'leave-balance' },
      { id: 'leave-apply', label: 'Leave Apply', icon: 'event_available', path: '/self-service/leave-apply', entryPath: '/self-service/leave-apply/entry', type: 'list-entry', section: 'self-service', module: 'leave-apply' },
      { id: 'loan-application', label: 'Loan Application', icon: 'account_balance', path: '/self-service/loan-application', entryPath: '/self-service/loan-application/entry', type: 'list-entry', section: 'self-service', module: 'loan-application' },
      { id: 'payslip', label: 'My Payslips', icon: 'receipt_long', path: '/self-service/payslip', type: 'screen', section: 'self-service', module: 'payslip' },
      { id: 'emp-incentives', label: 'Incentives', icon: 'military_tech', path: '/self-service/emp-incentives', type: 'screen', section: 'self-service', module: 'emp-incentives' },
    ],
  },
  {
    id: 'ess-team',
    label: 'Team & Directory',
    icon: 'groups',
    basePath: '/self-service/team',
    defaultPath: '/self-service/my-team',
    submenus: [
      { id: 'my-team', label: 'My Team', icon: 'diversity_3', path: '/self-service/my-team', type: 'screen', section: 'self-service', module: 'my-team' },
      { id: 'my-subordinates', label: 'My Subordinates', icon: 'supervised_user_circle', path: '/self-service/my-subordinates', type: 'screen', section: 'self-service', module: 'my-subordinates' },
      { id: 'search-employee', label: 'Search Employee', icon: 'person_search', path: '/self-service/search-employee', type: 'screen', section: 'self-service', module: 'search-employee' },
    ],
  },
]

export const MENU_STRUCTURE = [
  {
    id: 'dashboard',
    label: 'My Dashboard',
    icon: 'space_dashboard',
    basePath: '/dashboard',
    defaultPath: '/dashboard/personal',
    submenus: [
      { id: 'personal', label: 'Personal', icon: 'person', path: '/dashboard/personal', type: 'dashboard', privilege: 'DashboardPersonalView' },
      { id: 'team', label: 'Team', icon: 'groups', path: '/dashboard/team', type: 'dashboard', privilege: 'DashboardTeamView', requiredModule: 'nerve' },
      { id: 'financial', label: 'Financial', icon: 'payments', path: '/dashboard/financial', type: 'dashboard', privilege: 'DashboardFinancialView', requiredModule: 'nerve' },
      { id: 'calendar', label: 'Calendar', icon: 'calendar_month', path: '/dashboard/calendar', type: 'dashboard', privilege: 'DashboardCalendarView', requiredModule: 'bruno' },
    ]
  },
  {
    id: 'masters',
    label: 'Masters',
    icon: 'domain',
    basePath: '/masters',
    defaultPath: '/masters/company/list',
    // Categorized layout for the Topbar Canopy (Mega-Menu).
    // Flat `submenus` is computed from this at runtime via getAllMenuSubmenus().
    categories: [
      {
        id: 'organization',
        label: 'Organization',
        icon: 'corporate_fare',
        submenus: [
          { id: 'company', label: 'Company', icon: 'apartment', path: '/masters/company/list', entryPath: '/masters/company/entry', type: 'list-entry', section: 'masters', module: 'company', privilege: 'CompanyView', createPrivilege: 'CompanyAdd' },
          { id: 'branch', label: 'Branch', icon: 'location_city', path: '/masters/branch/list', entryPath: '/masters/branch/entry', type: 'list-entry', section: 'masters', module: 'branch', privilege: 'BranchView', createPrivilege: 'BranchAdd' },
          { id: 'department', label: 'Department', icon: 'workspaces', path: '/masters/department/list', entryPath: '/masters/department/entry', type: 'list-entry', section: 'masters', module: 'department', privilege: 'DepartmentView', createPrivilege: 'DepartmentAdd' },
          { id: 'roles', label: 'Roles', icon: 'shield_person', path: '/masters/roles/list', entryPath: '/masters/roles/entry', type: 'list-entry', section: 'masters', module: 'roles', privilege: 'RoleView', createPrivilege: 'RoleAdd' },
          { id: 'users', label: 'Users', icon: 'badge', path: '/masters/users/list', entryPath: '/masters/users/entry', type: 'list-entry', section: 'masters', module: 'users', privilege: 'UserView', createPrivilege: 'UserAdd' },
          { id: 'subscriptions', label: 'Subscriptions', icon: 'card_membership', path: '/masters/subscriptions', type: 'screen', section: 'masters', module: 'subscriptions', privilege: 'CompanyView' },
          { id: 'place', label: 'Place', icon: 'location_on', path: '/masters/place/list', entryPath: '/masters/place/entry', type: 'list-entry', section: 'masters', module: 'place', requiredModule: 'education' },
          { id: 'school-college', label: 'School/College', icon: 'school', path: '/masters/school-college/list', entryPath: '/masters/school-college/entry', type: 'list-entry', section: 'masters', module: 'school-college', requiredModule: 'education' },
          { id: 'classroom', label: 'Classroom', icon: 'meeting_room', path: '/masters/classroom/list', entryPath: '/masters/classroom/entry', type: 'list-entry', section: 'masters', module: 'classroom', requiredModule: 'education' },
        ]
      },
      {
        id: 'configuration',
        label: 'Configuration',
        icon: 'tune',
        submenus: [
          { id: 'project-master', label: 'Project Master', icon: 'architecture', path: '/masters/project-master/list', entryPath: '/masters/project-master/entry', type: 'list-entry', section: 'masters', module: 'project-master', privilege: 'ProjectView', createPrivilege: 'ProjectAdd', requiredModule: 'nerve' },
          { id: 'task-master', label: 'Task Master', icon: 'assignment', path: '/masters/task-master/list', entryPath: '/masters/task-master/entry', type: 'list-entry', section: 'masters', module: 'task-master', privilege: 'TaskMasterView', createPrivilege: 'TaskMasterAdd', requiredModule: 'nerve' },
          { id: 'job-master', label: 'Job Master', icon: 'inventory_2', path: '/masters/job-master/list', entryPath: '/masters/job-master/entry', type: 'list-entry', section: 'masters', module: 'job-master', privilege: 'JobMasterView', createPrivilege: 'JobMasterAdd', requiredModule: 'nerve' },
          { id: 'employee-group', label: 'Employee Group', icon: 'group', path: '/masters/employee-group/list', entryPath: '/masters/employee-group/entry', type: 'list-entry', section: 'masters', module: 'employee-group' },
          { id: 'holiday-master', label: 'Holiday Master', icon: 'calendar_today', path: '/masters/holiday-master/list', entryPath: '/masters/holiday-master/entry', type: 'list-entry', section: 'masters', module: 'holiday-master' },
          { id: 'courses', label: 'Courses', icon: 'menu_book', path: '/masters/courses/list', entryPath: '/masters/courses/entry', type: 'list-entry', section: 'masters', module: 'courses', requiredModule: 'education' },
          { id: 'batches', label: 'Batches', icon: 'groups_2', path: '/masters/batches/list', entryPath: '/masters/batches/entry', type: 'list-entry', section: 'masters', module: 'batches', requiredModule: 'education' },
          { id: 'subjects', label: 'Subjects', icon: 'science', path: '/masters/subjects/list', entryPath: '/masters/subjects/entry', type: 'list-entry', section: 'masters', module: 'subjects', requiredModule: 'education' },
          { id: 'schemes', label: 'Schemes', icon: 'schema', path: '/masters/schemes/list', entryPath: '/masters/schemes/entry', type: 'list-entry', section: 'masters', module: 'schemes', requiredModule: 'education' },
          { id: 'medium', label: 'Medium', icon: 'translate', path: '/masters/medium/list', entryPath: '/masters/medium/entry', type: 'list-entry', section: 'masters', module: 'medium', requiredModule: 'education' },
          { id: 'boards', label: 'Boards', icon: 'account_balance', path: '/masters/boards/list', entryPath: '/masters/boards/entry', type: 'list-entry', section: 'masters', module: 'boards', requiredModule: 'education' },
        ]
      },
      {
        id: 'financials',
        label: 'Financials',
        icon: 'payments',
        submenus: [
          { id: 'currency', label: 'Currency', icon: 'currency_exchange', path: '/masters/currency/list', entryPath: '/masters/currency/entry', type: 'list-entry', section: 'masters', module: 'currency', privilege: 'CompanyView', createPrivilege: 'CompanyAdd', requiredModule: 'nerve' },
          { id: 'inventory', label: 'Inventory', icon: 'inventory', path: '/masters/inventory/list', entryPath: '/masters/inventory/entry', type: 'list-entry', section: 'masters', module: 'inventory', requiredModule: 'education' },
          { id: 'inventory-group', label: 'Inventory Group', icon: 'category', path: '/masters/inventory-group/list', entryPath: '/masters/inventory-group/entry', type: 'list-entry', section: 'masters', module: 'inventory-group', requiredModule: 'education' },
          { id: 'brand', label: 'Brand', icon: 'sell', path: '/masters/brand/list', entryPath: '/masters/brand/entry', type: 'list-entry', section: 'masters', module: 'brand', requiredModule: 'education' },
          { id: 'boe-cha', label: 'BOE CHA', icon: 'receipt_long', path: '/masters/boe-cha/list', entryPath: '/masters/boe-cha/entry', type: 'list-entry', section: 'masters', module: 'boe-cha', requiredModule: 'education' },
          { id: 'boe-forwarder', label: 'BOE Forwarder', icon: 'local_shipping', path: '/masters/boe-forwarder/list', entryPath: '/masters/boe-forwarder/entry', type: 'list-entry', section: 'masters', module: 'boe-forwarder', requiredModule: 'education' },
          { id: 'acheads', label: 'Accounts Heads', icon: 'account_balance_wallet', path: '/masters/acheads/heads/list', type: 'list-entry', section: 'masters', module: 'acheads', requiredModule: 'education' },
          { id: 'payment-mode', label: 'Payment Mode', icon: 'credit_card', path: '/masters/payment-mode/list', entryPath: '/masters/payment-mode/entry', type: 'list-entry', section: 'masters', module: 'payment-mode', requiredModule: 'education' },
        ]
      },
      {
        id: 'demographics',
        label: 'Demographics',
        icon: 'people',
        submenus: [
          { id: 'relations', label: 'Relations', icon: 'family_restroom', path: '/masters/relation/list', entryPath: '/masters/relation/entry', type: 'list-entry', section: 'masters', module: 'relations', requiredModule: 'education' },
          { id: 'occupations', label: 'Occupations', icon: 'work', path: '/masters/occupation/list', entryPath: '/masters/occupation/entry', type: 'list-entry', section: 'masters', module: 'occupations', requiredModule: 'education' },
          { id: 'qualification', label: 'Qualifications', icon: 'school', path: '/masters/qualification/list', entryPath: '/masters/qualification/entry', type: 'list-entry', section: 'masters', module: 'qualification', requiredModule: 'education' },
          { id: 'caste', label: 'Caste', icon: 'diversity_3', path: '/masters/caste/list', entryPath: '/masters/caste/entry', type: 'list-entry', section: 'masters', module: 'caste', requiredModule: 'education' },
          { id: 'sub-caste', label: 'Sub-Caste', icon: 'diversity_2', path: '/masters/sub-caste/list', entryPath: '/masters/sub-caste/entry', type: 'list-entry', section: 'masters', module: 'sub-caste', requiredModule: 'education' },
        ]
      },
      {
        id: 'content-communication',
        label: 'Content & Communication',
        icon: 'campaign',
        submenus: [
          { id: 'remarks', label: 'Remarks', icon: 'comment', path: '/masters/remarks/list', entryPath: '/masters/remarks/entry', type: 'list-entry', section: 'masters', module: 'remarks', requiredModule: 'education' },
          { id: 'remarks-category', label: 'Remarks Category', icon: 'category', path: '/masters/remarks-category/list', entryPath: '/masters/remarks-category/entry', type: 'list-entry', section: 'masters', module: 'remarks-category', requiredModule: 'education' },
          { id: 'contact-category', label: 'Contact Category', icon: 'contacts', path: '/masters/contact-category/list', entryPath: '/masters/contact-category/entry', type: 'list-entry', section: 'masters', module: 'contact-category', requiredModule: 'education' },
          { id: 'help-videos', label: 'Help Videos', icon: 'video_library', path: '/masters/help-videos/list', entryPath: '/masters/help-videos/entry', type: 'list-entry', section: 'masters', module: 'help-videos', comingSoon: true },
        ]
      },
    ],
    // Flat submenus for backward compatibility with routing/permission utilities.
    // This is overridden at runtime below via getAllMenuSubmenus().
    get submenus() { return getAllMenuSubmenus(this) },
  },
  {
    id: 'admission',
    label: 'Admission',
    icon: 'school',
    basePath: '/admission',
    defaultPath: '/admission/students/list',
    requiredModule: 'education',
    categories: [
      {
        id: 'student-lifecycle',
        label: 'Student Lifecycle',
        icon: 'person_add',
        submenus: [
          { id: 'students', label: 'Students', icon: 'groups', path: '/admission/students/list', entryPath: '/admission/students/entry', type: 'list-entry', section: 'admission', module: 'students' },
          { id: 'student-landing', label: 'Landing Page', icon: 'web', path: '/admission/student-landing/list', entryPath: '/admission/student-landing/entry', type: 'list-entry', section: 'admission', module: 'student-landing' },
          { id: 'admission-form-setting', label: 'Form Setting', icon: 'tune', path: '/admission/admission-form-setting/list', entryPath: '/admission/admission-form-setting/entry', type: 'list-entry', section: 'admission', module: 'admission-form-setting' },
          { id: 'upload-excel', label: 'Upload Excel', icon: 'upload_file', path: '/admission/upload-excel/list', entryPath: '/admission/upload-excel/entry', type: 'custom', section: 'admission', module: 'upload-excel' },
        ],
      },
      {
        id: 'fees-billing',
        label: 'Fees & Issue Item',
        icon: 'payments',
        submenus: [
          { id: 'fees', label: 'Fees', icon: 'receipt_long', path: '/admission/fees/list', entryPath: null, hideCreate: true, type: 'report', section: 'admission', module: 'fees' },
          { id: 'installments', label: 'Installments', icon: 'calendar_month', path: '/admission/installments/list', entryPath: null, hideCreate: true, type: 'report', section: 'admission', module: 'installments' },
          { id: 'issue-item', label: 'Issue Item', icon: 'inventory_2', path: '/admission/issue-item/list', entryPath: '/admission/issue-item/entry', type: 'list-entry', section: 'admission', module: 'issue-item' },
        ],
      },
      {
        id: 'engagement-tracking',
        label: 'Engagement & Tracking',
        icon: 'insights',
        submenus: [
          { id: 'birthdays', label: 'Birthdays', icon: 'cake', path: '/admission/birthdays/list', entryPath: null, type: 'report', hideCreate: true, section: 'admission', module: 'birthdays' },
          { id: 'biometric-records', label: 'Biometric Records', icon: 'fingerprint', path: '/admission/biometric-records/list', entryPath: null, type: 'report', hideCreate: true, section: 'admission', module: 'biometric-records' },
          { id: 'analytics', label: 'Analytics', icon: 'monitoring', path: '/admission/analytics/list', entryPath: null, type: 'report', hideCreate: true, section: 'admission', module: 'analytics' },
        ],
      },
    ],
    get submenus() { return getAllMenuSubmenus(this) },
  },
  {
    id: 'lectures',
    label: 'Lectures',
    icon: 'cast_for_education',
    basePath: '/lectures',
    defaultPath: '/lectures/list',
    requiredModule: 'education',
    categories: [
      {
        id: 'scheduling-operations',
        label: 'Scheduling & Operations',
        icon: 'calendar_month',
        submenus: [
          { id: 'lectures-list', label: 'List of Lectures', icon: 'view_list', path: '/lectures/list', entryPath: '/lectures/entry', type: 'list-entry', section: 'lectures', module: 'lectures' },
          { id: 'timetable', label: 'Time Table', icon: 'calendar_view_week', path: '/lectures/timetable', entryPath: '/lectures/timetable/entry', type: 'list-entry', section: 'lectures', module: 'timetable' },
          { id: 'lecture-hours', label: 'Lecture Hours', icon: 'timelapse', path: '/lectures/hours', type: 'custom', section: 'lectures', module: 'hours' },
        ],
      },
      {
        id: 'academic-curriculum',
        label: 'Academic & Curriculum',
        icon: 'menu_book',
        submenus: [
          { id: 'syllabus', label: 'Syllabus', icon: 'auto_stories', path: '/lectures/syllabus', entryPath: '/lectures/syllabus/entry', type: 'list-entry', section: 'lectures', module: 'syllabus' },
        ],
      },
      {
        id: 'administration-tools',
        label: 'Administration & Tools',
        icon: 'tune',
        submenus: [
          { id: 'upload-excel', label: 'Upload Excel', icon: 'upload_file', path: '/lectures/upload', type: 'custom', section: 'lectures', module: 'upload' },
          { id: 'settings', label: 'Settings', icon: 'settings', path: '/lectures/settings', type: 'custom', section: 'lectures', module: 'settings' },
        ],
      },
    ],
    get submenus() { return getAllMenuSubmenus(this) },
  },
  {
    id: 'attendance',
    label: 'Attendance',
    icon: 'how_to_reg',
    basePath: '/attendance',
    defaultPath: '/attendance/daily',
    requiredModule: 'education',
    categories: [
      {
        id: 'attendance-tracking',
        label: 'Attendance Tracking',
        icon: 'fact_check',
        submenus: [
          { id: 'daily-attendance', label: 'Daily Attendance', icon: 'how_to_reg', path: '/attendance/daily', type: 'custom', section: 'attendance', module: 'daily' },
          { id: 'monthly-attendance', label: 'Monthly Attendance', icon: 'calendar_month', path: '/attendance/monthly', type: 'custom', section: 'attendance', module: 'monthly' },
        ],
      },
      {
        id: 'biometric-swipes',
        label: 'Biometric & Swipes',
        icon: 'fingerprint',
        submenus: [
          { id: 'biometric-records', label: 'Biometric Records', icon: 'badge', path: '/attendance/biometric', type: 'custom', section: 'attendance', module: 'biometric' },
          { id: 'upload-swipes', label: 'Upload Swipes', icon: 'upload_file', path: '/attendance/upload-swipes', type: 'custom', section: 'attendance', module: 'upload-swipes' },
        ],
      },
      {
        id: 'attendance-config',
        label: 'Configuration & Settings',
        icon: 'tune',
        submenus: [
          { id: 'attendance-settings', label: 'Settings', icon: 'settings', path: '/attendance/settings', type: 'custom', section: 'attendance', module: 'settings' },
        ],
      },
    ],
    get submenus() { return getAllMenuSubmenus(this) },
  },
  {
    id: 'tests',
    label: 'Tests & Exams',
    icon: 'quiz',
    basePath: '/education/tests',
    defaultPath: '/education/tests',
    requiredModule: 'education',
    categories: [
      {
        id: 'test-management',
        label: 'Examinations',
        icon: 'fact_check',
        submenus: [
          { id: 'tests-list', label: 'Tests List', icon: 'view_list', path: '/education/tests', entryPath: '/education/tests/entry', type: 'list-entry', section: 'tests', module: 'tests' },
          { id: 'test-groups', label: 'Test Groups', icon: 'category', path: '/education/tests/groups', entryPath: '/education/tests/groups/entry', type: 'list-entry', section: 'tests', module: 'groups' },
        ],
      },
      {
        id: 'test-config',
        label: 'Configuration & Settings',
        icon: 'tune',
        submenus: [
          { id: 'test-settings', label: 'Test Settings', icon: 'settings', path: '/education/tests/settings', type: 'custom', section: 'tests', module: 'settings' },
          { id: 'report-card-settings', label: 'Report Card Settings', icon: 'assignment', path: '/education/tests/report-card-settings', type: 'custom', section: 'tests', module: 'report-card-settings' },
        ],
      },
    ],
    get submenus() { return getAllMenuSubmenus(this) },
  },
  {
    id: 'remarks',
    label: 'Remarks',
    icon: 'rate_review',
    basePath: '/remarks',
    defaultPath: '/remarks/list',
    requiredModule: 'education',
    categories: [
      {
        id: 'remarks-management',
        label: 'Remarks Management',
        icon: 'rate_review',
        submenus: [
          { id: 'remarks-list', label: 'Student Remarks', icon: 'view_list', path: '/remarks/list', entryPath: '/remarks/entry', type: 'list-entry', section: 'remarks', module: 'remarks' },
        ],
      },
    ],
    get submenus() { return getAllMenuSubmenus(this) },
  },
  {
    id: 'cloud',
    label: 'Cloud',
    icon: 'cloud_sync',
    basePath: '/cloud',
    defaultPath: '/cloud/mobile-app',
    requiredModule: 'education',
    categories: [
      {
        id: 'digital-portals',
        label: 'Digital Platforms & Portals',
        icon: 'devices',
        submenus: [
          { id: 'mobile-app', label: 'Mobile App', icon: 'smartphone', path: '/cloud/mobile-app', type: 'custom', section: 'cloud', module: 'mobile-app' },
          { id: 'website', label: 'Website', icon: 'language', path: '/cloud/website', type: 'custom', section: 'cloud', module: 'website' },
        ],
      },
      {
        id: 'campus-engagement',
        label: 'Campus Engagement & Content',
        icon: 'campaign',
        submenus: [
          { id: 'notice', label: 'Notice', icon: 'notifications_active', path: '/cloud/notice/list', entryPath: '/cloud/notice/entry', type: 'list-entry', section: 'cloud', module: 'notice' },
          { id: 'events', label: 'Events', icon: 'event', path: '/cloud/events/list', entryPath: '/cloud/events/entry', type: 'list-entry', section: 'cloud', module: 'events' },
          { id: 'gallery', label: 'Gallery', icon: 'photo_library', path: '/cloud/gallery', type: 'list-entry', section: 'cloud', module: 'gallery' },
        ],
      },
      {
        id: 'inquiries-logs',
        label: 'Inquiries, Feedback & Logs',
        icon: 'forum',
        submenus: [
          { id: 'lead', label: 'Lead', icon: 'contact_phone', path: '/cloud/lead', type: 'custom', section: 'cloud', module: 'lead' },
          { id: 'feedback', label: 'Feedback', icon: 'rate_review', path: '/cloud/feedback/list', type: 'custom', section: 'cloud', module: 'feedback' },
          { id: 'student-logs', label: 'Student Logs', icon: 'history', path: '/cloud/student-logs', type: 'custom', section: 'cloud', module: 'student-logs' },
        ],
      },
    ],
    get submenus() { return getAllMenuSubmenus(this) },
  },
  {
    id: 'payroll',
    label: 'Payroll',
    icon: 'schedule',
    basePath: '/payroll',
    defaultPath: '/payroll/employee',
    requiredModule: 'payroll',
    categories: [
      {
        id: 'employee-management',
        label: 'Employee Management',
        icon: 'person',
        submenus: [
          { id: 'employee', label: 'Employee', icon: 'person', path: '/payroll/employee', entryPath: '/payroll/employee/entry', section: 'payroll', module: 'employee' },
          { id: 'employee-group', label: 'Employee Group', icon: 'group', path: '/payroll/employee-group', entryPath: '/payroll/employee-group/entry', type: 'list-entry', section: 'payroll', module: 'employee-group' },
        ]
      },
      {
        id: 'attendance-shift',
        label: 'Attendance & Shift',
        icon: 'alarm',
        submenus: [
          { id: 'shift-master', label: 'Shift Master', icon: 'schedule', path: '/payroll/shift-master', entryPath: '/payroll/shift-master/entry', section: 'payroll', module: 'shift-master' },
          { id: 'holiday-master', label: 'Holiday Master', icon: 'calendar_today', path: '/payroll/holiday-master', entryPath: '/payroll/holiday-master/entry', type: 'list-entry', section: 'payroll', module: 'holiday-master' },
          { id: 'biometrics', label: 'Biometrics', icon: 'fingerprint', path: '/payroll/biometrics', section: 'payroll', module: 'biometrics' },
          { id: 'manual-punch', label: 'Manual Punch', icon: 'touch_app', path: '/payroll/manual-punch', entryPath: '/payroll/manual-punch/entry', section: 'payroll', module: 'manual-punch' },
          { id: 'remote-attandance', label: 'Remote Attandance', icon: 'language', path: '/payroll/remote-attandance', entryPath: '/payroll/remote-attandance/entry', section: 'payroll', module: 'remote-attandance' },
          { id: 'attendance-history', label: 'Attendance History', icon: 'history', path: '/payroll/attendance-history', section: 'payroll', module: 'attendance-history' },
          { id: 'attendance-rules', label: 'Attendance Rules', icon: 'rule', path: '/payroll/attendance-rules', entryPath: '/payroll/attendance-rules/entry', section: 'payroll', module: 'attendance-rules' },
        ]
      },
      {
        id: 'leave-management',
        label: 'Leave Management',
        icon: 'event_busy',
        submenus: [
          { id: 'leave-master', label: 'Leave Master', icon: 'domain_verification', path: '/payroll/leave-master', entryPath: '/payroll/leave-master/entry', section: 'payroll', module: 'leave-master' },
          { id: 'leave-rules', label: 'Leave Rules', icon: 'gavel', path: '/payroll/leave-rules', entryPath: '/payroll/leave-rules/entry', section: 'payroll', module: 'leave-rules' },
          { id: 'leave-application', label: 'Leave Application', icon: 'assignment', path: '/payroll/leave-application', entryPath: '/payroll/leave-application/entry', section: 'payroll', module: 'leave-application' },
        ]
      },
      {
        id: 'compensation-loan',
        label: 'Compensation & Loan',
        icon: 'payments',
        submenus: [
          { id: 'payheads', label: 'PayHeads', icon: 'paid', path: '/payroll/payheads', entryPath: '/payroll/payheads/entry', section: 'payroll', module: 'payheads' },
          { id: 'incentives', label: 'Incentives', icon: 'add_card', path: '/payroll/incentives', entryPath: '/payroll/incentives/entry', section: 'payroll', module: 'incentives' },
          { id: 'deductions', label: 'Deductions', icon: 'money_off', path: '/payroll/deductions', entryPath: '/payroll/deductions/entry', section: 'payroll', module: 'deductions' },
          { id: 'loans', label: 'Loans', icon: 'account_balance', path: '/payroll/loans', entryPath: '/payroll/loans/entry', section: 'payroll', module: 'loans' },
        ]
      },
      {
        id: 'payroll-processing',
        label: 'Payroll Processing',
        icon: 'settings_suggest',
        submenus: [
          { id: 'daily-process', label: 'Daily Process', icon: 'published_with_changes', path: '/payroll/daily-process', entryPath: '/payroll/daily-process/run', section: 'payroll', module: 'daily-process' },
          { id: 'monthly-process', label: 'Monthly Process', icon: 'event_repeat', path: '/payroll/monthly-process', entryPath: '/payroll/monthly-process/run', section: 'payroll', module: 'monthly-process' },
          { id: 'salary-process', label: 'Salary Process', icon: 'receipt_long', path: '/payroll/salary-process', entryPath: '/payroll/salary-process/process', section: 'payroll', module: 'salary-process' },
        ]
      },
      {
        id: 'payroll-settings',
        label: 'Settings',
        icon: 'settings',
        submenus: [
          { id: 'settings', label: 'Settings', icon: 'settings', path: '/payroll/settings', section: 'payroll', module: 'settings' }
        ]
      }
    ],
    get submenus() { return getAllMenuSubmenus(this) }
  },
  {
    id: 'bruno',
    label: 'Bruno',
    icon: 'insights',
    basePath: '/bruno',
    defaultPath: '/bruno/dashboard',
    requiredModule: 'bruno',
    submenus: [
      { id: 'dashboard', label: 'Dashboard', icon: 'dashboard', path: '/bruno/dashboard', type: 'dashboard', section: 'bruno', module: 'dashboard', privilege: 'ProductivityDashboardView' },
      { id: 'sessions', label: 'Sessions', icon: 'list_alt', path: '/bruno/sessions', type: 'list', section: 'bruno', module: 'sessions', privilege: 'ProductivitySessionsView' },
      { id: 'red-domains', label: 'Red Domains', icon: 'block', path: '/bruno/red-domains', type: 'custom', section: 'bruno', module: 'red-domains', privilege: 'ProductivityRedDomainsView' },
    ]
  },
  {
    id: 'nerve',
    label: 'Nerve',
    icon: 'account_tree',
    basePath: '/nerve',
    defaultPath: '/nerve/project/list',
    requiredModule: 'nerve',
    submenus: [
      { id: 'project', label: 'Project', icon: 'deployed_code', path: '/nerve/project/list', entryPath: '/nerve/project/entry', type: 'list-entry', section: 'nerve', module: 'project', privilege: 'ProjectView', createPrivilege: 'ProjectAdd' },
      { id: 'task', label: 'Task', icon: 'assignment', path: '/nerve/task/list', entryPath: '/nerve/task/entry', type: 'list-entry', section: 'nerve', module: 'task', privilege: 'TaskView', createPrivilege: 'TaskAdd' },
      { id: 'job', label: 'Job', icon: 'inventory_2', path: '/nerve/job/list', entryPath: '/nerve/job/entry', type: 'list-entry', section: 'nerve', module: 'job', privilege: 'JobView', createPrivilege: 'JobAdd' },
      { id: 'timesheet', label: 'Timesheet', icon: 'schedule', path: '/nerve/timesheet/list', entryPath: '/nerve/timesheet/entry', type: 'list-entry', section: 'nerve', module: 'timesheet', privilege: 'TimesheetView', createPrivilege: 'TimesheetAdd' },
      { id: 'allocation', label: 'Resource Allocation', icon: 'groups', path: '/allocation/board', type: 'custom', section: 'nerve', module: 'allocation', privilege: 'ResourceAllocationView' },
      { id: 'ticketsync', label: 'Ticket Integration', icon: 'sync', path: '/nerve/ticketsync/list', type: 'list-entry', section: 'nerve', module: 'ticketsync', privilege: 'TicketSyncView' },
      { id: 'reports', label: 'Reports', icon: 'summarize', path: '/reports/project', type: 'reports', section: 'nerve', module: 'reports', privilege: 'ProjectView' },
    ]
  },
  {
    id: 'approval',
    label: 'Approval',
    icon: 'fact_check',
    basePath: '/approval',
    defaultPath: '/approval/masters/list',
    submenus: [
      { id: 'masters', label: 'Masters', icon: 'category', path: '/approval/masters/list', type: 'approval', section: 'approval', module: 'masters', privilege: 'ApprovalMastersView' },
      { id: 'timesheet', label: 'Timesheet', icon: 'event_note', path: '/approval/timesheet/list', type: 'approval', section: 'approval', module: 'timesheet', privilege: 'ApprovalTimesheetView', requiredModule: 'nerve' },
      { id: 'leave', label: 'Leave', icon: 'event_busy', path: '/approval/leave/list', type: 'approval', section: 'approval', module: 'leave', privilege: 'ApprovalLeaveView', requiredModule: 'bruno' },
      { id: 'productivity-hours', label: 'Productivity Hours', icon: 'schedule', path: '/approval/productivity-hours/list', type: 'approval', section: 'approval', module: 'productivity-hours', privilege: 'ApprovalProductivityHoursView', requiredModule: 'bruno' },
    ]
  },
  {
    id: 'analytics',
    label: 'Analytics',
    icon: 'monitoring',
    basePath: '/analytics',
    defaultPath: '/analytics/user',
    requiredModule: 'analytics',
    submenus: [
      { id: 'user', label: 'User', icon: 'group', path: '/analytics/user', type: 'analytics', privilege: 'AnalyticsUserView' },
      { id: 'project', label: 'Project', icon: 'account_tree', path: '/analytics/project', type: 'analytics', privilege: 'AnalyticsProjectView' },
      { id: 'task', label: 'Task', icon: 'assignment', path: '/analytics/task', type: 'analytics', privilege: 'AnalyticsTaskView' },
      { id: 'job', label: 'Job', icon: 'work', path: '/analytics/job', type: 'analytics', privilege: 'AnalyticsJobView' },
    ]
  },
  {
    id: 'bridge',
    label: 'Bridge',
    icon: 'forum',
    basePath: '/bridge',
    defaultPath: '/bridge/hub',
    requiredModule: 'bridge',
    submenus: [
      { id: 'hub', label: 'Hub', icon: 'forum', path: '/bridge/hub', type: 'communication', privilege: 'CommunicationView' },
      { id: 'thread', label: 'Threads', icon: 'person_add', path: '/bridge/thread', type: 'communication', privilege: 'CommunicationView' },
    ]
  },
  {
    id: 'loop',
    label: 'Loop',
    icon: 'call',
    basePath: '/loop',
    defaultPath: '/loop/call-center',
    requiredModule: 'telephony',
    submenus: [
      { id: 'call-center', label: 'Call Centre', icon: 'support_agent', path: '/loop/call-center', type: 'telephony', privilege: 'CallCentreAccess' },
      { id: 'call-logs', label: 'Call Logs', icon: 'history', path: '/loop/call-logs', type: 'telephony', privilege: 'CallLogView' },
      { id: 'settings', label: 'Settings', icon: 'settings_phone', path: '/loop/settings', type: 'telephony', privilege: 'CallCentreAccess' }
    ]
  },
  {
    id: 'reports',
    label: 'Reports',
    icon: 'summarize',
    basePath: '/reports',
    defaultPath: '/reports/masters',
    requiredModule: 'reports',
    submenus: [
      { id: 'masters', label: 'Masters', icon: 'domain', path: '/reports/masters', type: 'reports', privilege: 'ReportsAllView' },
      { id: 'financial', label: 'Financial', icon: 'payments', path: '/reports/financial', type: 'reports', privilege: 'ReportsAllView' },
      { id: 'project', label: 'Project', icon: 'deployed_code', path: '/reports/project', type: 'reports', privilege: 'ReportsAllView' },
      { id: 'user', label: 'User', icon: 'person', path: '/reports/user', type: 'reports', privilege: 'ReportsAllView' },
      { id: 'task', label: 'Task', icon: 'task', path: '/reports/task', type: 'reports', privilege: 'ReportsAllView' },
      { id: 'productivity', label: 'Productivity', icon: 'insights', path: '/reports/productivity', type: 'reports', privilege: 'ReportsAllView' },
      { id: 'integration', label: 'Integration', icon: 'hub', path: '/reports/integration', type: 'reports', privilege: 'ReportsAllView' },
      { id: 'api-logs', label: 'API Logs', icon: 'article', path: '/reports/api-logs', type: 'reports', privilege: 'ReportsAllView' }
    ]
  },
  {
    id: 'audit-logs',
    label: 'Audit Logs',
    icon: 'fact_check',
    basePath: '/audit-logs',
    defaultPath: '/audit-logs',
    requiredModule: 'audit_logs',
    submenus: [
      { id: 'audit-trail', label: 'Audit Trail', icon: 'fact_check', path: '/audit-logs', type: 'custom', privilege: 'AuditLogsView' },
    ]
  },
  {
    id: 'support',
    label: 'Support',
    icon: 'support_agent',
    basePath: '/support',
    defaultPath: '/support/tickets/list',
    submenus: [
      { id: 'tickets', label: 'Support Tickets', icon: 'confirmation_number', path: '/support/tickets/list', entryPath: '/support/tickets/entry', type: 'list-entry', section: 'support', module: 'tickets' },
    ]
  }
]

const MASTER_ROWS = {
  company: [
    ['COMP-001', 'Bridge Global Holdings', 'Enterprise SaaS', 'London', 'Active'],
    ['COMP-002', 'Bridge Pacific Ventures', 'Infrastructure', 'Singapore', 'Active'],
    ['COMP-003', 'Bridge Labs Europe', 'R&D', 'Berlin', 'Pending'],
    ['COMP-004', 'Bridge Operations US', 'Operations', 'Austin', 'Active']
  ],
  branch: [
    ['BR-110', 'London Central', 'United Kingdom', 'Sarah Chen', 'Active'],
    ['BR-221', 'Singapore Hub', 'Singapore', 'Min Lee', 'Active'],
    ['BR-348', 'Madrid Node', 'Spain', 'Elena Rossi', 'Onboarding'],
    ['BR-509', 'Austin Yard', 'United States', 'David Holt', 'Active']
  ],
  department: [
    ['DEP-01', 'Engineering', 'Bridge Global', 'Alex Mercer', 'Active'],
    ['DEP-04', 'Operations', 'Bridge Global', 'Julian Frost', 'Active'],
    ['DEP-07', 'Design', 'Bridge Labs', 'Ava Clarke', 'Active'],
    ['DEP-09', 'Finance', 'Bridge Global', 'Martha Hill', 'Pending']
  ],
  roles: [
    ['RL-101', 'Principal Architect', 'System-wide', '26', 'Active'],
    ['RL-204', 'Project Lead', 'Project-level', '48', 'Active'],
    ['RL-311', 'Audit Manager', 'Finance', '09', 'Active'],
    ['RL-422', 'Access Reviewer', 'Security', '13', 'Draft']
  ],
  users: [
    ['BR-0922', 'Alex Mercer', 'Engineering', 'Principal Architect', 'Active'],
    ['BR-1104', 'Elena Rodriguez', 'Product Strategy', 'Product Lead', 'Active'],
    ['BR-1582', 'David Kim', 'Sales Ops', 'Account Manager', 'On Leave'],
    ['BR-2210', 'Sofia Rossi', 'Cybersecurity', 'Security Auditor', 'Active']
  ]
}

const PM_ROWS = {
  project: [
    ['PRJ-301', 'Nebula Cloud Rollout', 'Bridge Global', 'Q4', 'In Progress'],
    ['PRJ-455', 'Titan ERP Modernization', 'Global Industries', 'Q3', 'In Progress'],
    ['PRJ-512', 'Vector Compliance Revamp', 'Acme Corp', 'Q2', 'Completed'],
    ['PRJ-689', 'Bridge API Consolidation', 'Bridge Labs', 'Q4', 'Planning']
  ],
  task: [
    ['TSK-404', 'Audit API contracts', 'Nebula Cloud', 'High', 'In Progress'],
    ['TSK-511', 'UI density review', 'Titan ERP', 'Medium', 'Review'],
    ['TSK-620', 'Load testing suite', 'Bridge API', 'High', 'Pending'],
    ['TSK-777', 'Cost review exports', 'Compliance', 'Low', 'Complete']
  ],
  job: [
    ['J-9042', 'API Middleware Refactor', 'Nebula Cloud', '65%', 'In Progress'],
    ['J-8911', 'Design System V2', 'Project Titan', '100%', 'Completed'],
    ['J-9105', 'Security Audit Q4', 'Global Ops', '12%', 'Pending'],
    ['J-9122', 'Mobile UI Kit', 'Enterprise Engine', '95%', 'Overdue']
  ],
  timesheet: [
    ['TS-1142', 'Alex Mercer', 'Week 15', '42h', 'Submitted'],
    ['TS-1148', 'Elena Rodriguez', 'Week 15', '38h', 'Approved'],
    ['TS-1151', 'David Kim', 'Week 15', '34h', 'Pending'],
    ['TS-1156', 'Sofia Rossi', 'Week 15', '40h', 'Submitted']
  ],
  ticketsync: [
    ['SYNC-401', 'Manual Sync Trigger', 'Bridge PM', 'Success', '2m ago'],
    ['SYNC-402', 'Webhook Delta Pull', 'Bridge PM', 'Success', '8m ago'],
    ['SYNC-403', 'Manual Sync Trigger', 'Bridge PM', 'Pending', '12m ago'],
    ['SYNC-404', 'Nightly Bulk Sync', 'Bridge PM', 'Success', '1h ago']
  ]
}

const APPROVAL_ROWS = {
  timesheet: [
    ['REQ-7801', 'Alex Mercer', 'Week 15', '42h', 'Pending'],
    ['REQ-7807', 'Elena Rodriguez', 'Week 15', '38h', 'Pending'],
    ['REQ-7812', 'Sofia Rossi', 'Week 15', '40h', 'Escalated'],
    ['REQ-7820', 'David Kim', 'Week 15', '34h', 'Pending']
  ],
  leave: [
    ['LEV-192', 'Martha Hill', 'Annual Leave', '3 Days', 'Pending'],
    ['LEV-194', 'Julian Frost', 'Sick Leave', '1 Day', 'Pending'],
    ['LEV-197', 'Ava Clarke', 'Personal Leave', '2 Days', 'Escalated'],
    ['LEV-201', 'Nina Paul', 'Annual Leave', '5 Days', 'Pending']
  ],
  expenses: [
    ['EXP-920', 'David Kim', 'Travel', '$1,240', 'Pending'],
    ['EXP-936', 'Elena Rodriguez', 'Tools', '$450', 'Pending'],
    ['EXP-947', 'Alex Mercer', 'Client Meeting', '$680', 'Escalated'],
    ['EXP-952', 'Sofia Rossi', 'Workshop', '$390', 'Pending']
  ]
}

export const MODULE_META = {
  masters: {
    company: {
      listTitle: 'Company Registry',
      entryTitle: 'Company Entry',
      createLabel: 'Create Company',
      columns: ['Code', 'Company Name', 'Domain', 'HQ', 'Status'],
      rows: MASTER_ROWS.company,
      fields: ['Company Code', 'Company Name', 'Industry Domain', 'Registered Email', 'Primary Phone', 'Headquarters Address']
    },
    branch: {
      listTitle: 'Branch Registry',
      entryTitle: 'Branch Entry',
      createLabel: 'Create Branch',
      columns: ['Code', 'Branch Name', 'Country', 'Branch Head', 'Status'],
      rows: MASTER_ROWS.branch,
      fields: ['Branch Code', 'Branch Name', 'Parent Company', 'Branch Head', 'Contact Number', 'Branch Address']
    },
    department: {
      listTitle: 'Department Registry',
      entryTitle: 'Department Entry',
      createLabel: 'Create Department',
      columns: ['Code', 'Department', 'Company', 'Lead', 'Status'],
      rows: MASTER_ROWS.department,
      fields: ['Department Code', 'Department Name', 'Parent Company', 'Department Lead', 'Cost Center', 'Description']
    },
    roles: {
      listTitle: 'Role Configuration',
      entryTitle: 'Role Configuration Entry',
      createLabel: 'Create Role',
      columns: ['Role ID', 'Role Name', 'Scope', 'Users', 'Status'],
      rows: MASTER_ROWS.roles,
      fields: ['Role Name', 'Role Code', 'Access Scope', 'Privilege Set', 'Default Dashboard', 'Notes']
    },
    users: {
      listTitle: 'User Directory',
      entryTitle: 'User Entry',
      createLabel: 'Create User',
      columns: ['Employee ID', 'Name', 'Department', 'Role', 'Status'],
      rows: MASTER_ROWS.users,
      fields: ['Employee ID', 'Full Name', 'Official Email', 'Department', 'Role', 'Reporting Manager']
    },
    'task-master': {
      listTitle: 'Task Master Registry',
      entryTitle: 'Task Master Entry',
      createLabel: 'Create Task Master',
      columns: ['Code', 'Task Type Name', 'Priority', 'SLA Hours', 'Status'],
      rows: [],
      fields: ['Task Type Name', 'Priority', 'SLA Hours', 'Default Effort Estimate', 'Skill Tags']
    },
    'job-master': {
      listTitle: 'Job Master Registry',
      entryTitle: 'Job Master Entry',
      createLabel: 'Create Job Master',
      columns: ['Code', 'Job Type Name', 'Parent Task Type', 'Seq Order', 'Status'],
      rows: [],
      fields: ['Job Type Name', 'Parent Task Master', 'Seq Order', 'Default Effort Estimate', 'SLA Hours']
    },
    brand: {
      listTitle: 'Brand Registry',
      entryTitle: 'Brand Entry',
      createLabel: 'Create Brand',
      columns: ['Code', 'Brand Name', 'Status'],
      rows: [],
      fields: ['Brand Code', 'Brand Name', 'Description']
    },
    'payment-mode': {
      listTitle: 'Payment Mode Registry',
      entryTitle: 'Payment Mode Entry',
      createLabel: 'Create Payment Mode',
      columns: ['Code', 'Payment Mode', 'Linked Bank Account', 'Status'],
      rows: [],
      fields: ['Payment Mode Code', 'Payment Mode Name', 'Linked Bank Account']
    },
    inventory: {
      listTitle: 'Inventory Registry',
      entryTitle: 'Inventory Item Entry',
      createLabel: 'Create Inventory Item',
      columns: ['Code', 'Item Name', 'UPC', 'HSN/SAC', 'Qty', 'Group', 'Status'],
      rows: [],
      fields: ['Item Code', 'Item Name', 'UPC', 'HSN/SAC', 'Quantity', 'Item Group']
    }
  },
  'project-management': {
    project: {
      listTitle: 'Project Inventory',
      entryTitle: 'Project Configuration Entry',
      createLabel: 'Create Project',
      columns: ['Project ID', 'Project Name', 'Customer', 'Quarter', 'Status'],
      rows: PM_ROWS.project,
      fields: ['Project Code', 'Project Name', 'Client Name', 'Project Owner', 'Start Date', 'Estimated Completion']
    },
    task: {
      listTitle: 'Task Ledger',
      entryTitle: 'Task Configuration',
      createLabel: 'Create Task',
      columns: ['Task ID', 'Task Name', 'Project', 'Priority', 'Status'],
      rows: PM_ROWS.task,
      fields: ['Task Code', 'Task Name', 'Project', 'Priority', 'Assignee', 'Task Description']
    },
    job: {
      listTitle: 'Job Management',
      entryTitle: 'Job Entry',
      createLabel: 'Create Job',
      columns: ['Job ID', 'Job Name', 'Project', 'Utilization', 'Status'],
      rows: PM_ROWS.job,
      fields: ['Job Code', 'Job Name', 'Category', 'Project', 'Responsible Team', 'Execution Notes']
    },
    timesheet: {
      listTitle: 'Timesheet Registry',
      entryTitle: 'Timesheet Entry',
      createLabel: 'Create Timesheet',
      columns: ['Sheet ID', 'Employee', 'Period', 'Hours', 'Status'],
      rows: PM_ROWS.timesheet,
      fields: ['Employee', 'Week Start', 'Project', 'Task', 'Total Hours', 'Manager Notes']
    },
    ticketsync: {
      listTitle: 'Ticket Inflow Registry',
      entryTitle: 'Ticket Integration',
      createLabel: 'Run Manual Sync',
      columns: ['Sync ID', 'Action', 'Source', 'Status', 'Last Updated'],
      rows: PM_ROWS.ticketsync,
      fields: ['Trigger Type', 'Source Connector', 'Scope', 'Remarks']
    }
  },
  approval: {
    company: {
      listTitle: 'Company Approvals',
      columns: ['Company Code', 'Company Name', 'GST Number', 'Created By', 'Status'],
      rows: []
    },
    timesheet: {
      listTitle: 'Timesheet Approvals',
      columns: ['Request ID', 'Employee', 'Period', 'Hours', 'Status'],
      rows: APPROVAL_ROWS.timesheet
    },
    leave: {
      listTitle: 'Leave Approvals',
      columns: ['Request ID', 'Employee', 'Leave Type', 'Duration', 'Status'],
      rows: APPROVAL_ROWS.leave
    },
    'productivity-hours': {
      listTitle: 'Productivity-Hour Approvals',
      columns: ['Request ID', 'Employee', 'Department', 'Requested', 'Status'],
      rows: []
    }
  }
}
MODULE_META.nerve = MODULE_META['project-management']


export const ANALYTICS_META = {
  user: { title: 'User Analytics Insights', subtitle: 'Identity, usage and access behavior analytics.' },
  project: { title: 'Project Performance Analytics', subtitle: 'Delivery health across project portfolios.' },
  task: { title: 'Task Performance Intelligence', subtitle: 'Task throughput and completion quality metrics.' },
  job: { title: 'Job Productivity Intelligence', subtitle: 'Operational velocity and utilization for jobs.' },
}

export const REPORTS_META = {
  masters: { title: 'Masters Reports', subtitle: 'Organization and identity master reporting.' },
  financial: { title: 'Financial Reports', subtitle: 'Generate fiscal and profitability reporting snapshots.' },
  project: { title: 'Project Management Reports', subtitle: 'Project status, budget and timeline reporting.' },
  user: { title: 'User Management Reports', subtitle: 'Identity and role distribution reporting.' },
  task: { title: 'Task Analytics Reports', subtitle: 'Task performance and cycle-time reporting.' },
  productivity: { title: 'Productivity Reports', subtitle: 'Throughput and execution efficiency reporting.' },
  integration: { title: 'Integration Reports', subtitle: 'API and integration reliability reporting.' },
  'api-logs': { title: 'API Logs Reports', subtitle: 'Endpoint logs and technical audit reporting.' }
}

export function getDefaultPath(menuIdOrPath, menus = MENU_STRUCTURE) {
  if (!menuIdOrPath) return '/dashboard/personal'
  const byId = menus.find((menu) =>
    menu.id === menuIdOrPath ||
    (menuIdOrPath === 'nerve' && menu.id === 'project-management') ||
    (menuIdOrPath === 'project-management' && menu.id === 'nerve') ||
    (menuIdOrPath === 'bruno' && menu.id === 'productivity') ||
    (menuIdOrPath === 'productivity' && menu.id === 'bruno') ||
    (menuIdOrPath === 'bridge' && menu.id === 'communication') ||
    (menuIdOrPath === 'communication' && menu.id === 'bridge') ||
    (menuIdOrPath === 'loop' && menu.id === 'telephony') ||
    (menuIdOrPath === 'telephony' && menu.id === 'loop')
  )
  if (byId) return byId.defaultPath

  const byPath = menus.find((menu) => menuIdOrPath.startsWith(menu.basePath))
  return byPath ? byPath.defaultPath : '/dashboard/personal'
}

export function matchesSubmenuPath(pathname, submenuPath) {
  if (!pathname || !submenuPath) return false
  if (pathname === submenuPath) return true
  if (submenuPath.endsWith('/list')) {
    const base = submenuPath.replace(/\/list$/, '')
    const segments = base.split('/').filter(Boolean)
    // If base is a single segment (e.g. '/lectures'), only match base, base/list, or base/entry
    if (segments.length <= 1) {
      return (
        pathname === base ||
        pathname === `${base}/list` ||
        pathname === `${base}/entry` ||
        pathname.startsWith(`${base}/entry/`)
      )
    }
    return pathname === base || pathname.startsWith(`${base}/`)
  }
  return pathname.startsWith(`${submenuPath}/`)
}

export function getActiveMenu(pathname, menus = MENU_STRUCTURE) {
  if (!Array.isArray(menus) || menus.length === 0) return null

  // 1. Special route aliases
  if (pathname.startsWith('/allocation')) {
    return menus.find((menu) => menu.id === 'nerve' || menu.id === 'project-management') || menus[0]
  }

  // 2. Direct match by child submenu or entryPath (takes precedence to avoid module basePath collisions)
  for (const menu of menus) {
    const submenus = getAllMenuSubmenus(menu)
    if (
      submenus.some(
        (s) =>
          matchesSubmenuPath(pathname, s.path) ||
          (s.entryPath && matchesSubmenuPath(pathname, s.entryPath))
      )
    ) {
      return menu
    }
  }

  // 3. Strict module basePath matching (e.g. /masters/* strictly belongs to masters, /payroll/* to payroll)
  const menuByBasePath = menus.find((menu) => menu.basePath && pathname.startsWith(menu.basePath))
  if (menuByBasePath) {
    return menuByBasePath
  }

  return menus[0]
}

export function getActiveSubmenu(pathname, menus = MENU_STRUCTURE) {
  const activeMenu = getActiveMenu(pathname, menus)
  if (!activeMenu) return null
  const submenus = getAllMenuSubmenus(activeMenu)
  if (!submenus || submenus.length === 0) return null

  if (pathname.startsWith('/allocation')) {
    return submenus.find((submenu) => submenu.id === 'allocation') || submenus[0]
  }

  // Map Accounts Heads sub-tabs in Masters (/masters/acheads/*) to acheads submenu
  if (pathname.startsWith('/masters/acheads')) {
    const acheadsSub = submenus.find((submenu) => submenu.id === 'acheads')
    if (acheadsSub) return acheadsSub
  }

  // 1. Exact match on path or entryPath
  const exactMatch = submenus.find(
    (s) => s.path === pathname || (s.entryPath && s.entryPath === pathname)
  )
  if (exactMatch) return exactMatch

  // 2. Sub-route match on entryPath (e.g. /lectures/timetable/entry/123 -> timetable)
  const entryMatch = submenus.find(
    (s) => s.entryPath && pathname.startsWith(`${s.entryPath}/`)
  )
  if (entryMatch) return entryMatch

  // 3. Fallback to matchesSubmenuPath
  return submenus.find((submenu) => matchesSubmenuPath(pathname, submenu.path)) || submenus[0]
}

export function getModuleMeta(section, module) {
  return MODULE_META?.[section]?.[module] || null
}

export function getAnalyticsMeta(module) {
  return ANALYTICS_META[module] || ANALYTICS_META.user
}

export function getReportsMeta(module) {
  return REPORTS_META[module] || REPORTS_META.financial
}

export function formatRouteLabel(segment) {
  if (!segment) return ''
  return segment
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (part) => part.toUpperCase())
}

export function getMenuCategories(menu) {
  if (Array.isArray(menu?.categories)) {
    return menu.categories
  }
  const flat = Array.isArray(menu?._submenus) ? menu._submenus : (Array.isArray(menu?.submenus) ? menu.submenus : [])
  return flat.length ? [{ id: '_default', label: '', icon: '', submenus: flat }] : []
}

export function getAllMenuSubmenus(menu) {
  if (Array.isArray(menu?.categories)) {
    return menu.categories.flatMap((cat) => Array.isArray(cat.submenus) ? cat.submenus : [])
  }
  if (Array.isArray(menu?._submenus)) {
    return menu._submenus
  }
  return Array.isArray(menu?.submenus) ? menu.submenus : []
}

export function getFirstAccessibleSubmenuPath(menu, { hasPrivilege, hasModule, isAdmin } = {}) {
  if (!menu) return '/'
  const submenus = getAllMenuSubmenus(menu)
  if (!submenus || !submenus.length) return menu.defaultPath || '/'

  const accessible = submenus.find((s) => {
    if (s.comingSoon) return false
    if (!isAdmin && s.privilege && hasPrivilege && !hasPrivilege(s.privilege)) return false
    if (hasModule) {
      const requiredModule = s.requiredModule || getRequiredModuleForPath(s.path)
      if (requiredModule && !hasModule(requiredModule)) return false
    }
    return true
  })

  return accessible?.path || menu.defaultPath || '/'
}

/**
 * Compiles the user's authorized, personalized navigation tree:
 * 1. Filters out menus & submenus whose requiredModule is not in user's active tenant modules.
 * 2. Filters out submenus whose privilege is not granted to the user (bypassed if isAdmin).
 * 3. Dynamically calculates `canCreate` for each accessible submenu screen.
 * 4. Resolves `defaultPath` to the first accessible submenu path (no hardcoded dead routes).
 * 5. Automatically omits empty categories and empty top-level menus.
 */
export function buildAuthorizedNavigation({ privileges = [], modules = [], isAdmin = false, role = '', is_employee = false } = {}) {
  const grantedPrivileges = new Set(privileges || [])
  const normalizedModules = new Set((modules || []).map(normalizeModuleCode))

  const isEmployeeUser =
    role === 'employee' ||
    is_employee === true ||
    (!isAdmin && normalizedModules.has('self-service') && normalizedModules.size === 1)

  if (isEmployeeUser) {
    return EMPLOYEE_MENU_STRUCTURE.map((menu) => ({
      ...menu,
      submenus: (menu.submenus || []).map((sub) => ({ ...sub, canCreate: true })),
    }))
  }

  const hasModule = (mod) => checkModuleEntitlement(mod, modules)

  const hasPrivilege = (priv) => {
    if (!priv) return true
    if (isAdmin) return true
    return grantedPrivileges.has(priv)
  }

  const isSubmenuAccessible = (sub) => {
    if (sub.comingSoon) return false
    const reqMod = sub.requiredModule || getRequiredModuleForPath(sub.path)
    if (reqMod && !hasModule(reqMod)) return false
    if (!hasPrivilege(sub.privilege)) return false
    return true
  }

  const corpModules = ['bruno', 'nerve', 'bridge', 'loop', 'analytics', 'reports', 'audit_logs']
  const hasCorp = corpModules.some((m) => normalizedModules.has(m))
  const isEducationOnlyUser = normalizedModules.has('education') && !hasCorp

  const resultMenus = []

  for (const rawMenu of MENU_STRUCTURE) {
    if (rawMenu.id === 'support') continue

    const menuReqMod = rawMenu.requiredModule || getRequiredModuleForPath(rawMenu.basePath)
    if (menuReqMod && !hasModule(menuReqMod)) {
      continue
    }

    if (rawMenu.id === 'approval' && isEducationOnlyUser) continue

    let authorizedSubmenus = []
    let authorizedCategories = null

    if (Array.isArray(rawMenu.categories)) {
      authorizedCategories = []
      for (const cat of rawMenu.categories) {
        const catSubmenus = []
        for (const sub of (cat.submenus || [])) {
          if (isSubmenuAccessible(sub)) {
            const canCreate = isAdmin || (Boolean(sub.createPrivilege) && hasPrivilege(sub.createPrivilege))
            const subItem = { ...sub, canCreate }
            catSubmenus.push(subItem)
            authorizedSubmenus.push(subItem)
          }
        }
        if (catSubmenus.length > 0) {
          authorizedCategories.push({
            ...cat,
            submenus: catSubmenus,
          })
        }
      }
      if (authorizedCategories.length === 0 && authorizedSubmenus.length === 0) {
        continue
      }
    } else {
      const flat = Array.isArray(rawMenu.submenus) ? rawMenu.submenus : []
      for (const sub of flat) {
        if (isSubmenuAccessible(sub)) {
          const canCreate = isAdmin || (Boolean(sub.createPrivilege) && hasPrivilege(sub.createPrivilege))
          const subItem = { ...sub, canCreate }
          authorizedSubmenus.push(subItem)
        }
      }
      if (authorizedSubmenus.length === 0) {
        continue
      }
    }

    // Prioritize explicit defaultPath if declared and accessible; otherwise prefer first accessible submenu within the module's basePath
    const isExplicitDefaultAccessible =
      rawMenu.defaultPath &&
      authorizedSubmenus.some((s) => s.path === rawMenu.defaultPath || matchesSubmenuPath(rawMenu.defaultPath, s.path))

    let defaultPath = isExplicitDefaultAccessible
      ? rawMenu.defaultPath
      : (authorizedSubmenus.find((s) => s.path?.startsWith(rawMenu.basePath))?.path || authorizedSubmenus[0]?.path || rawMenu.defaultPath || rawMenu.basePath)

    if (rawMenu.id === 'dashboard' && isEducationOnlyUser) {
      defaultPath = '/dashboard'
    }

    const menuObj = {
      ...rawMenu,
      defaultPath,
      submenus: authorizedSubmenus,
    }
    if (authorizedCategories) {
      menuObj.categories = authorizedCategories
    }

    resultMenus.push(menuObj)
  }

  return sortNavigationMenus(resultMenus)
}

/**
 * Pinned ordering specification for main sidebar navigation:
 * - Top: My Dashboard (dashboard), followed by Productivity (productivity)
 * - Middle: Dynamic modules sorted alphabetically (A-Z) by display label
 * - End: Analytics, Reports, Audit Logs, Masters in exact order
 */
export const PINNED_TOP_MENU_IDS = ['dashboard', 'bruno', 'productivity']
export const PINNED_BOTTOM_MENU_IDS = ['analytics', 'reports', 'audit-logs', 'masters']

export function normalizeMenuId(id) {
  return String(id || '').toLowerCase().replace(/_/g, '-')
}

/**
 * Deterministically sorts an array of menu objects according to enterprise standard:
 * 1. Pinned Top: Dashboard, Productivity
 * 2. Alphabetical Middle (A-Z) by label (locale-aware comparison)
 * 3. Pinned End: Analytics, Reports, Audit Logs, Masters
 */
export function sortNavigationMenus(menus) {
  if (!Array.isArray(menus)) return []
  if (menus.length > 0 && menus.some((m) => m?.id?.startsWith('ess-'))) {
    return menus
  }

  const topGroup = []
  const middleGroup = []
  const bottomGroup = []

  for (const menu of menus) {
    if (!menu) continue
    const normId = normalizeMenuId(menu.id)
    const topIdx = PINNED_TOP_MENU_IDS.indexOf(normId)
    const bottomIdx = PINNED_BOTTOM_MENU_IDS.indexOf(normId)

    if (topIdx !== -1) {
      topGroup.push({ menu, rank: topIdx })
    } else if (bottomIdx !== -1) {
      bottomGroup.push({ menu, rank: bottomIdx })
    } else {
      middleGroup.push(menu)
    }
  }

  topGroup.sort((a, b) => a.rank - b.rank)
  bottomGroup.sort((a, b) => a.rank - b.rank)
  middleGroup.sort((a, b) => (a.label || '').localeCompare(b.label || '', undefined, { sensitivity: 'base' }))

  return [
    ...topGroup.map((g) => g.menu),
    ...middleGroup,
    ...bottomGroup.map((g) => g.menu),
  ]
}

/**
 * Checks whether a navigation item (menu, category, or submenu)
 * has nested child items, submenus, options, or categories.
 */
export function hasChildNavItems(item) {
  if (!item) return false
  if (Array.isArray(item.categories) && item.categories.length > 0) return true
  if (Array.isArray(item.submenus) && item.submenus.length > 0) return true
  if (Array.isArray(item.children) && item.children.length > 0) return true
  if (Array.isArray(item.options) && item.options.length > 0) return true
  return false
}
